// extracted by mini-css-extract-plugin
export default {"container":"iconComp_container__WGxGG","primary":"iconComp_primary__OzPrr","outline":"iconComp_outline__6331V"};